module.exports = __webpack_public_path__ + "assets/imgs/logos/google.1d6410c648f236d940f0f770e6063b6b.png";